import { useMemo } from 'react'

import { useUser } from '../../providers/Auth/hooks'
import type { NetworkTalentsResponse } from '../apollo/types'
import { useJmtNetworksQuery, useNetworkTalentsQuery } from '../apollo/types'

const usePlayerTypes = (): NetworkTalentsResponse | undefined => {
    const me = useUser()
    const networks = useJmtNetworksQuery()

    const playerTypeNetwork = useMemo(() =>
        networks?.data?.jmtNetworks.JMTnetworks.collection.find((network) => network.caption === 'Join.My.Talent.Engine.Marketplace.PlayerTypes')
    , [networks])

    const { data: { networkTalents } = { } } = useNetworkTalentsQuery({
        skip: !playerTypeNetwork?.id || !me?.user,
        variables: {
            networkId: playerTypeNetwork?.id ?? '',
        },
    })

    return networkTalents
}

export default usePlayerTypes
